import React from "react";
import AgentManagementPage from "layouts/shared/AgentManagementPage";
import { useUserContext } from "context/UserContext";
import { useTranslation } from "react-i18next";

function AgentManagementBK() {
  const { roleLevel } = useUserContext() || {};
  const { t } = useTranslation("agentManagement");
  const title = roleLevel ? t("titleBk") : t("titleSp");
  return <AgentManagementPage title={title} />;
}

export default AgentManagementBK;
